/**
 * Common types shared between the apps-monitor frontend and backend plugins.
 *
 * @packageDocumentation
 */
export * from './types';

/** Shared so the FE routeRef path and BE pluginId stay in sync. */
export const APPS_MONITOR_PLUGIN_ID = 'apps-monitor';
